export default class URLParamsHelper {
  constructor() {
    this.grabParams()
  }

  getParam(name) {
    this.grabParams()
    return this.URLParams.get(name)
  }

  grabParams() {
    this.URLParams = new URLSearchParams(decodeURIComponent(window.location.search))
  }

  removeParam(name) {
    this.grabParams()
    this.URLParams.delete(name)
    this.setWindowLocation()
  }

  setParam(name, value) {
    this.grabParams()
    this.URLParams.set(name, value)
    this.setWindowLocation()
  }

  setWindowLocation() {
    window.history.replaceState({}, '', `${window.location.pathname}?${this.URLParams}`)
  }
}
